import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about-alumni',
  templateUrl: './about-alumni.component.html',
  styleUrls: ['./about-alumni.component.scss']
})
export class AboutAlumniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
